<h2 mat-dialog-title>Supplier Info</h2>

<mat-dialog-content>
  @if (loading) {
  <div class="loading-container">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
  } @else if (notFound) {
  <div class="empty-state">No supplier profile found for {{ data.supplierUsername || 'this supplier' }}.</div>
  } @else if (profile) {
  <div class="info-container">

    <div class="info-section">
      <h3>Identity</h3>
      <div class="info-row">
        <span class="label">Username:</span>
        <span class="value">{{ profile.username }}</span>
      </div>
      <div class="info-row">
        <span class="label">Name:</span>
        <span class="value">{{ profile.name || 'N/A' }}</span>
      </div>
      <div class="info-row">
        <span class="label">Phone:</span>
        <span class="value copyable" (click)="copyToClipboard(profile.phone)">
          {{ profile.phone || 'N/A' }}
          @if (profile.phone) {
          <mat-icon>content_copy</mat-icon>
          }
        </span>
      </div>
      @if (profile.email) {
      <div class="info-row">
        <span class="label">Email:</span>
        <span class="value">{{ profile.email }}</span>
      </div>
      }
    </div>

    <div class="info-section">
      <h3>Payout destinations</h3>
      @if (destinations.length === 0) {
      <div class="info-row"><span class="value">None saved</span></div>
      }
      @for (d of destinations; track d.id) {
      <div class="info-row">
        <span class="label">{{ d.label }} · {{ d.method_name }}@if (!d.method_active) { (inactive) }:</span>
        <span class="value copyable" dir="ltr" (click)="copyToClipboard(d.account)">
          {{ d.account }}
          <mat-icon>content_copy</mat-icon>
        </span>
      </div>
      @if (d.holder_name) {
      <div class="info-row">
        <span class="label">Holder:</span>
        <span class="value">{{ d.holder_name }}</span>
      </div>
      }
      }
    </div>

  </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>
